export default class {
    
    /*@ngInject*/
    constructor($http, DESCARGAS_URL){
        Object.assign(this, {$http, DESCARGAS_URL});
    }
    
    getDescargas(){
        return this.$http.get(this.DESCARGAS_URL);
    }
    
    agregarDescarga(descarga){
        return this.$http.post(this.DESCARGAS_URL, descarga);
    }
    
    eliminarDescarga(id){
        return this.$http.delete(this.DESCARGAS_URL + '/' + id);
    }
    
}


// WEBPACK FOOTER //
// ./client/app/descargas-route/descargas.service.js